import { FunctionComponent } from 'react';

// Utilities
import classnames from 'classnames';

// Contexts
import { useDataTransfer } from '@Components/Utils/DataTransfer';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Component
import Image from '@Components/Utils/Image';

// Styles
import styles from './Introduce.module.scss';

// Icons

interface IntroduceProps {
    className?: string;
}

const Introduce: FunctionComponent<IntroduceProps> = (props) => {
    const { doctor } = useDataTransfer();
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);
    const graduateYear = doctor?.profile?.graduateYear;

    return (
        <div className={className}>
            <div className={styles.body}>
                <div className={styles.title}>Giới thiệu</div>
                <div className={styles.content}>
                    <Image className={styles.icon_exp} src="/assets/tra-cuu/bac-si/experience_icon.png" />

                    <div className={styles.text}>
                        {graduateYear && <span className={styles.experience}>{new Date().getFullYear() - graduateYear} năm kinh nghiệm</span>}
                        <div className={styles.description}>{doctor?.profile?.about}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Introduce.defaultProps = {
    className: '',
};

export default Introduce;
